// App.js
import React, { useEffect, useState } from "react";
import { WheelOfFortune } from "./components/WheelOfFortune";

function App() {
  const [initData, setInitData] = useState(null);

  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (!tg) {
      console.warn("[App] Telegram WebApp object not found");
      return;
    }

    tg.ready();
    tg.expand();

    console.log("[App] tg.initDataUnsafe =", tg.initDataUnsafe);
    console.log("[App] tg.initData =", tg.initData);

    // ✅ ВАЖНО: сюда отправляем СТРОКУ initData
    setInitData(tg.initData || "");
  }, []);

  if (initData == null) {
    return <div style={{ color: "#fff" }}>Загрузка...</div>;
  }

  // ✅ В компонент летит строка initData
  return <WheelOfFortune initData={initData} />;
}

export default App;
